export enum TabsList {
  CurrentUsers = 'currentUsers',
  PendingUsers = 'pendingUsers',
  DisabledUsers = 'disabledUsers',
}
